export default __webpack_public_path__ + "static/media/3093.1a1eb4f3.jpg";